import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  quote: string;
  imageUrl?: string;
}
export function TestimonialCard({
  name,
  age,
  quote,
  imageUrl
}: TestimonialCardProps) {
  return <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 my-6 shadow-sm" data-id="element-83">
      <div className="flex items-center gap-1 mb-3" data-id="element-84">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-[#FFD700] text-[#FFD700]" data-id="element-85" />)}
      </div>
      <blockquote className="font-serif text-gray-700 italic mb-4 leading-relaxed" data-id="element-86">
        "{quote}"
      </blockquote>
      <div className="flex items-center gap-3" data-id="element-87">
        {imageUrl ? <img src={imageUrl} alt={name} className="w-10 h-10 rounded-full object-cover" data-id="element-88" /> : <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center text-gray-500 font-bold text-xs" data-id="element-89">
            {name.charAt(0)}
          </div>}
        <div data-id="element-90">
          <p className="font-sans font-bold text-sm text-gray-900" data-id="element-91">{name}</p>
          <p className="font-sans text-xs text-gray-500" data-id="element-92">
            Verified Buyer, Age {age}
          </p>
        </div>
      </div>
    </div>;
}